import { Grid, IconButton, TextField, makeStyles } from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";
import { showEditItemsDialog } from "../../../../../items-edit/items-edit-slice";
import { showDeleteItemsDialog } from "../../../../../items-delete/items-delete-slice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getItemDetailsDataService } from "./item-information-list-service";
import { db } from "../../../../../../../../firebase";
import ItemInformationListLoading from "./item-information-list-loading";

const useStyles = makeStyles((theme) => ({
    tableHeader: {
      background: "#111111",
      height: "100%",
      color: "#fbbbd3",
      fontSize: 14,
    },
    button: {
      background: "#111111",
      color: "#fbbbd3",
      justifyContent: "right",
      '&:hover': {
        backgroundColor: '#fbbbd3',
        color: '#111111',
      },
    },
    buttonText: {
      color: "#111111",
      '&:hover': {
        backgroundColor: '#fbbbd3',
        color: '#111111',
    },
    },
    title: {
      color:"#111111",
      marginBottom: 20,
    }
}));

const ItemInformationList = (props) => {
    const classes = useStyles();
    const item_id = props.item_id;
    const isLoading = useSelector((state) => state.itemInformationListSlice.isLoading);
    const formData = props.formData;
    // const formData = useSelector((state) => state.itemInformationListSlice.itemInformation);
    const dispatch = useDispatch();

    useEffect(() => {
        if (item_id) {
            const fetchData = async () => {
                try {
                    await getItemDetailsDataService(dispatch, db, "items", item_id);
                } catch(e) {
                    console.error("ItemTabs fetchData error: ", e);
                }
            };
            fetchData();
        }
    }, [item_id]);

    // open edit dialog
    const handleEditOpen = (row) => {
        dispatch(showEditItemsDialog(row));
    };

    // open delete dialog
    const handleDeleteOpen = (row) => {
        dispatch(showDeleteItemsDialog(row));
    };

    const thisData = {
        ...formData,
        id: item_id
    };

    // if (isLoading) {
    //     return <ItemInformationListLoading/>
    // }

    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton
                        className={classes.buttonText}
                        onClick={() => handleEditOpen(thisData)}
                    >
                        <Edit/>
                    </IconButton>
                    <IconButton
                        className={classes.buttonText}
                        onClick={() => handleDeleteOpen(thisData)}
                    >
                        <Delete/>
                    </IconButton>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Code"
                        variant="filled"
                        fullWidth
                        name="code"
                        value={formData.code}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Name"
                        variant="filled"
                        fullWidth
                        name="name"
                        value={formData.name}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Description"
                        variant="filled"
                        fullWidth
                        name="description"
                        value={formData.description}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Original Price"
                        variant="filled"
                        fullWidth
                        name="original_price"
                        value={formData.original_price}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Type"
                        variant="filled"
                        fullWidth
                        name="type"
                        value={formData.type}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Status"
                        variant="filled"
                        fullWidth
                        name="status"
                        value={formData.status}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Category"
                        variant="filled"
                        fullWidth
                        name="category"
                        value={formData.category}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Rent %"
                        variant="filled"
                        fullWidth
                        name="rent_percent"
                        value={formData.rent_percent}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Rent Price"
                        variant="filled"
                        fullWidth
                        name="rent_percent"
                        value={formData.rent_price}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Deposit %"
                        variant="filled"
                        fullWidth
                        name="deposit_percent"
                        value={formData.deposit_percent}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Deposit"
                        variant="filled"
                        fullWidth
                        name="deposit"
                        value={formData.deposit}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Increase %"
                        variant="filled"
                        fullWidth
                        name="increase"
                        value={formData.increase}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Unit Price"
                        variant="filled"
                        fullWidth
                        name="unit_price"
                        value={formData.unit_price}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="filled-basic"
                        label="Piece(s)"
                        variant="filled"
                        fullWidth
                        name="pieces"
                        value={formData.pieces}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default ItemInformationList;